import { useState } from 'react';

import { LIST_PAGINATION_MODEL } from '../../../../../../store/modules/app/models';
import { useAccountUserDetailVisitorLogListQuery } from '../query/useAccountUserDetailVisitorLogListQuery';
import toastMsg from '../../../../../../lib/toastMsg';
import accountUserToastMsg from '../../../../../../constants/service/toastMsg/accountUserToastMsg';
import { UserDetailVisitorLogType, PaginationType } from '../types/userDetailVisitorLog';

export interface IUseAccountUserDetailVisitorLogListViewModel {
  visitorTimeLineList: UserDetailVisitorLogType[];
  paginateVisitorLogList: (paginate: PaginationType) => void;
  visitorLogListPagination: PaginationType;
}

export const useAccountUserDetailVisitorLogListViewModel = (
  userId: number,
  isActive: boolean,
): IUseAccountUserDetailVisitorLogListViewModel => {
  const [pagination, setPagination] = useState(LIST_PAGINATION_MODEL);
  const { data } = useAccountUserDetailVisitorLogListQuery<UserDetailVisitorLogType[]>({
    userId,
    pagination,
    options: {
      enabled: !!userId && isActive,
      placeholderData: { data: { visitorTimeLineList: { list: [], totalCnt: 0 } }, status: 0 },
      onSuccess: () => toastMsg.success(accountUserToastMsg.GET_USER_DETAIL_VISITOR_LOG_LIST_REQUEST_SUCCESS),
      onError: (err) => {
        toastMsg.error(accountUserToastMsg.GET_USER_DETAIL_VISITOR_LOG_LIST_REQUEST_ERROR, err);
      },
      select: (result) => result.data.visitorTimeLineList.list,
    },
  });

  return {
    visitorTimeLineList: data as UserDetailVisitorLogType[],
    paginateVisitorLogList: setPagination,
    visitorLogListPagination: pagination,
  };
};
